import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';
import Brand from '../common/Brand';
import { ROUTES } from '../../utils/constants';
import './PublicLayout.css';

// Sections of the home page, reachable from every public page.
const NAV_LINKS = [
  { to: '/', label: 'Home' },
  { to: { pathname: '/', hash: '#how-it-works' }, label: 'How it works' },
  { to: { pathname: '/', hash: '#who-its-for' }, label: "Who it's for" },
  { to: { pathname: '/', hash: '#trust' }, label: 'Trust & privacy' },
  { to: '/about', label: 'About' },
  { to: '/pricing', label: 'Pricing' },
  { to: '/faq', label: 'FAQ' },
  { to: '/contact', label: 'Contact' }
];

const PublicHeader = () => {
  const { isAuthenticated, loading } = useAuth();
  const { pathname, hash } = useLocation();
  const [open, setOpen] = useState(false);

  // Close the phone menu after choosing something.
  useEffect(() => {
    setOpen(false);
  }, [pathname, hash]);

  return (
    <header className="public-header">
      <div className="public-container public-header__inner">
        <Link to={ROUTES.HOME} className="public-header__brand"><Brand /></Link>

        <nav id="public-nav" className={`public-header__nav ${open ? 'is-open' : ''}`} aria-label="Main">
          {NAV_LINKS.map(({ to, label }) => (
            <Link key={label} to={to}>{label}</Link>
          ))}
        </nav>

        <div className="public-header__actions">
          {loading ? null : isAuthenticated ? (
            <Link to={ROUTES.DASHBOARD} className="public-btn public-btn--primary">Go to dashboard</Link>
          ) : (
            <>
              <Link to={ROUTES.LOGIN} className="public-btn public-btn--ghost">Log in</Link>
              <Link to={ROUTES.REGISTER} className="public-btn public-btn--primary">Get started</Link>
            </>
          )}
          <button
            type="button"
            className="public-header__menu"
            aria-label="Menu"
            aria-expanded={open}
            aria-controls="public-nav"
            onClick={() => setOpen((o) => !o)}
          >
            <span aria-hidden="true">{open ? '✕' : '☰'}</span>
          </button>
        </div>
      </div>
    </header>
  );
};

export default PublicHeader;
